import { safeDeepGet } from 'iotera-base/json'
import { isFunction } from 'iotera-base/object'
import { S_EXPIRE, S_LOGIN, domainIsTenant as dit, S_TENANT, pathPrefixS, LOGIN } from "../../../routes/routes"
import Result from 'iotera-base/result'

/* Credentials Token */
import { removeTokenDit } from '../../../auth/token'

export function setCallbackGlobal(props) {
  const setCallback = safeDeepGet(props, ['wSetWCallbackConfig'])
  const domainIsTenant = dit(props)
  const isTenant = safeDeepGet(domainIsTenant, ['isTenant'])
  const domain = safeDeepGet(domainIsTenant, ['domain'])
  const pathName = safeDeepGet(props, ['location', 'pathname'])
  const loginTenant = S_TENANT + S_LOGIN
  if (isFunction(setCallback)) {
    setCallback({
      finished: (id, result) => {
        const code = safeDeepGet(result, ['code'])
        const http = safeDeepGet(Result, ['HTTP'])
        const unauthorized = safeDeepGet(http, ['UNAUTHORIZED'])
        const paymentRequired = safeDeepGet(http, ['PAYMENT_REQUIRED'])
        // tes payment
        // const code = paymentRequired
        if (code === paymentRequired) {
          return props.history.push({
            pathname: S_EXPIRE,
            state: {
              isTenant: isTenant
            }
          })
        }
        else if (code === unauthorized) {
          removeTokenDit(domainIsTenant)
          if (isTenant) {
            return props.history.push({
              pathname: loginTenant,
              search: '?redirectURL=' + pathName
            })
          }
          else {
            const prefixS = pathPrefixS(domain, isTenant)
            const prefixSLogin = prefixS + LOGIN
            return props.history.push({
              pathname: prefixSLogin,
              search: '?redirectURL=' + pathName
            })
          }
        }
      }
    })
  }
  else {
    return
  }
}

export function unsetCallbackGlobal(props) {
  const unsetCallback = safeDeepGet(props, ['wUnsetWCallbackConfig'])
  if (isFunction(unsetCallback)) {
    unsetCallback({})
  }
  else {
    return
  }
}